export class ATDLEnumModel {
  public enumId: string = null;
  public wireValue: string = null;
  public uiRep: string = null;

  constructor(enumId?: string, wireValue?: string, uiRep?: string) {
    this.enumId = enumId;
    this.wireValue = wireValue;
    this.uiRep = uiRep;
  }
}
